export const mockPrendas = [
  {
    id: 1,
    cliente_id: 1,
    nombre: 'Traje de lana azul marino',
    categoria: 'Trajes',
    color: 'Azul marino',
    ocasion: ['trabajo', 'eventos'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-navy-blue-wool-suit-hanging-minimal-wardrobe-luxury-tailoring-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=301&orientation=portrait',
    frecuencia_uso: 12,
    estacion: ['otoño', 'invierno', 'primavera'],
    talla: '50',
    material: 'Lana virgen',
    notas: 'Ajustado en la cintura, manga cortada por Anthony.',
    activa: true,
    sort_order: 0,
  },
  {
    id: 2,
    cliente_id: 1,
    nombre: 'Camisa blanca popelín',
    categoria: 'Camisas',
    color: 'Blanco',
    ocasion: ['trabajo', 'social', 'eventos'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-white-poplin-dress-shirt-hanging-minimal-wardrobe-luxury-menswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=302&orientation=portrait',
    frecuencia_uso: 28,
    estacion: ['todo_el_año'],
    talla: '40',
    material: 'Algodón egipcio',
    notas: 'Cuello italiano, planchada semanalmente.',
    activa: true,
    sort_order: 1,
  },
  {
    id: 3,
    cliente_id: 1,
    nombre: 'Jersey de cachemira gris',
    categoria: 'Jerséis',
    color: 'Gris perla',
    ocasion: ['trabajo', 'social'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-grey-cashmere-sweater-hanging-minimal-wardrobe-luxury-menswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=303&orientation=portrait',
    frecuencia_uso: 8,
    estacion: ['otoño', 'invierno'],
    talla: 'L',
    material: 'Cachemira 100%',
    notas: 'Para looks business casual. No usar con jeans.',
    activa: true,
    sort_order: 2,
  },
  {
    id: 4,
    cliente_id: 1,
    nombre: 'Chinos beige',
    categoria: 'Pantalones',
    color: 'Beige',
    ocasion: ['social', 'fin_de_semana'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-beige-chino-pants-hanging-minimal-wardrobe-luxury-menswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=304&orientation=portrait',
    frecuencia_uso: 6,
    estacion: ['primavera', 'verano', 'otoño'],
    talla: '50',
    material: 'Algodón elástico',
    notas: 'Combinar con cinturón marrón claro.',
    activa: true,
    sort_order: 3,
  },
  {
    id: 5,
    cliente_id: 1,
    nombre: 'Americana de tweed',
    categoria: 'Americanas',
    color: 'Tweed marrón',
    ocasion: ['trabajo', 'social'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-brown-tweed-blazer-hanging-minimal-wardrobe-luxury-menswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=305&orientation=portrait',
    frecuencia_uso: 5,
    estacion: ['otoño', 'invierno'],
    talla: '50',
    material: 'Tweed inglés',
    notas: 'Look universitario e intelectual. Ideal con vaqueros oscuros.',
    activa: true,
    sort_order: 4,
  },
  {
    id: 6,
    cliente_id: 1,
    nombre: 'Polo de piqué azul',
    categoria: 'Polos',
    color: 'Azul eléctrico',
    ocasion: ['fin_de_semana', 'deporte'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-blue-pique-polo-shirt-hanging-minimal-wardrobe-luxury-menswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=306&orientation=portrait',
    frecuencia_uso: 4,
    estacion: ['primavera', 'verano'],
    talla: 'L',
    material: 'Algodón piqué',
    notas: 'Solo para contextos informales y deportivos.',
    activa: true,
    sort_order: 5,
  },
  {
    id: 7,
    cliente_id: 2,
    nombre: 'Vestido de seda burdeos',
    categoria: 'Vestidos',
    color: 'Burdeos',
    ocasion: ['eventos', 'social'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-burgundy-silk-dress-hanging-minimal-wardrobe-luxury-womenswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=307&orientation=portrait',
    frecuencia_uso: 3,
    estacion: ['otoño', 'invierno'],
    talla: 'M',
    material: 'Seda 100%',
    notas: 'Eventos de noche. Largo midi.',
    activa: true,
    sort_order: 0,
  },
  {
    id: 8,
    cliente_id: 2,
    nombre: 'Blusa de seda blanca',
    categoria: 'Blusas',
    color: 'Blanco',
    ocasion: ['trabajo', 'social'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-white-silk-blouse-hanging-minimal-wardrobe-luxury-womenswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=308&orientation=portrait',
    frecuencia_uso: 15,
    estacion: ['todo_el_año'],
    talla: 'M',
    material: 'Seda natural',
    notas: 'Combinable con todo. Requiere lavado en seco.',
    activa: true,
    sort_order: 1,
  },
  {
    id: 9,
    cliente_id: 3,
    nombre: 'Americana de lino crudo',
    categoria: 'Americanas',
    color: 'Crudo',
    ocasion: ['social', 'eventos'],
    imagen_url: 'https://readdy.ai/api/search-image?query=elegant-natural-linen-blazer-hanging-minimal-wardrobe-luxury-menswear-soft-lighting-neutral-background-fashion-editorial-style&width=400&height=500&seq=309&orientation=portrait',
    frecuencia_uso: 7,
    estacion: ['primavera', 'verano'],
    talla: '52',
    material: 'Lino 100%',
    notas: 'Perfecta para veranos en el sur de España.',
    activa: true,
    sort_order: 0,
  },
];

export const categoriasPrenda = [
  'Trajes',
  'Americanas',
  'Camisas',
  'Pantalones',
  'Jerséis',
  'Polos',
  'Corbatas',
  'Zapatos',
  'Cinturones',
  'Ropa exterior',
  'Sportswear',
  'Vestidos',
  'Blusas',
];

export const ocasionesPrenda = [
  { value: 'trabajo', label: 'Trabajo' },
  { value: 'social', label: 'Social' },
  { value: 'eventos', label: 'Eventos' },
  { value: 'deporte', label: 'Deporte' },
  { value: 'fin_de_semana', label: 'Fin de semana' },
];

export const estacionesPrenda = [
  { value: 'primavera', label: 'Primavera' },
  { value: 'verano', label: 'Verano' },
  { value: 'otoño', label: 'Otoño' },
  { value: 'invierno', label: 'Invierno' },
  { value: 'todo_el_año', label: 'Todo el año' },
];

export const mockLooksCalendario = [
  {
    id: 1,
    cliente_id: 1,
    fecha: '2026-05-06',
    titulo: 'Reunión con inversores',
    notas: 'Ambiente formal, evitar colores estridentes.',
    prendas_ids: [1, 2],
    ocasion: 'trabajo',
    estacion: 'primavera',
    estado: 'planeado',
  },
  {
    id: 2,
    cliente_id: 1,
    fecha: '2026-05-08',
    titulo: 'Cena de networking',
    notas: 'Look elegante pero no excesivamente formal.',
    prendas_ids: [3, 4, 5],
    ocasion: 'social',
    estacion: 'otoño',
    estado: 'planeado',
  },
  {
    id: 3,
    cliente_id: 1,
    fecha: '2026-05-10',
    titulo: 'Partido de pádel',
    notas: 'Ropa deportiva apropiada.',
    prendas_ids: [6],
    ocasion: 'deporte',
    estacion: 'verano',
    estado: 'usado',
    foto_real_url: 'https://readdy.ai/api/search-image?query=stylish-man-casual-sporty-outfit-blue-polo-pants-tennis-club-terrace-naturallight-minimal-elegant-athleisure-look&width=600&height=450&seq=501&orientation=landscape',
    calificacion: 4,
    comentario_cliente: 'Muy cómodo para jugar, aunque haría falta un cinturón marrón.',
  },
  {
    id: 4,
    cliente_id: 2,
    fecha: '2026-05-12',
    titulo: 'Conferencia en Madrid',
    notas: 'Look ejecutivo femenino.',
    prendas_ids: [7, 8],
    ocasion: 'trabajo',
    estacion: 'primavera',
    estado: 'planeado',
  },
  {
    id: 5,
    cliente_id: 1,
    fecha: '2026-04-22',
    titulo: 'Cena de empresa',
    notas: 'Evento en el Ritz. Nivel de formalidad alto.',
    prendas_ids: [1, 2],
    ocasion: 'eventos',
    estacion: 'primavera',
    estado: 'usado',
    foto_real_url: 'https://readdy.ai/api/search-image?query=elegant-man-formal-navy-suit-white-shirt-evening-event-ritz-hotel-lobby-warm-lighting-luxury-minimal-editorial-style&width=600&height=450&seq=502&orientation=landscape',
    calificacion: 5,
    comentario_cliente: 'Perfecto. Muchos cumplidos de los socios.',
  },
  {
    id: 6,
    cliente_id: 1,
    fecha: '2026-04-15',
    titulo: 'Brunch dominical',
    notas: 'Look relajado pero elegante.',
    prendas_ids: [3, 4],
    ocasion: 'fin_de_semana',
    estacion: 'otoño',
    estado: 'usado',
    calificacion: 3,
    comentario_cliente: 'El jersey un poco abrigado para abril, hubiera preferido algo más ligero.',
  },
];

export const mockRecomendaciones = [
  {
    id: 1,
    cliente_id: 1,
    tipo: 'combinacion',
    titulo: 'Look inteligente para esta semana',
    descripcion: 'Tu traje azul marino + camisa blanca + corbata de seda gris = combinación perfecta para reuniones formales.',
    leida: false,
    fecha: '2026-05-05',
  },
  {
    id: 2,
    cliente_id: 1,
    tipo: 'alerta',
    titulo: 'Prenda poco utilizada detectada',
    descripcion: 'Tu polo azul eléctrico solo se ha usado 1 vez en los últimos 30 días. Considera si realmente encaja en tu estilo.',
    leida: false,
    fecha: '2026-05-04',
  },
  {
    id: 3,
    cliente_id: 1,
    tipo: 'sugerencia',
    titulo: 'Hueco detectado: cinturón negro formal',
    descripcion: 'No tienes un cinturón negro de cuero formal para combinar con tu traje azul marino. Anthony recomienda añadir uno.',
    leida: true,
    fecha: '2026-05-03',
  },
  {
    id: 4,
    cliente_id: 1,
    tipo: 'combinacion',
    titulo: 'Look de fin de semana optimizado',
    descripcion: 'Jersey de cachemira gris + chinos beige + zapatos marrón derby = look inteligente casual ideal para brunch.',
    leida: false,
    fecha: '2026-05-02',
  },
  {
    id: 5,
    cliente_id: 2,
    tipo: 'sugerencia',
    titulo: 'Nuevo blazer recomendado',
    descripcion: 'Para tus conferencias internacionales, un blazer de seda negra aportaría mayor sofisticación a tu imagen.',
    leida: false,
    fecha: '2026-05-01',
  },
];